import * as React from 'react';

interface ClassDetails {
  name: string;
  oldDate: string;
  oldTime: string;
  newDate: string;
  newTime: string;
  duration: string;
  location: string;
  instructor: string;
  meetingLink?: string;
  reasonForReschedule?: string;
}

interface ClassRescheduledEmailProps {
  name?: string;
  company?: string;
  supportEmail?: string;
  domain?: string;
  classDetails?: ClassDetails;
  accountLink?: string;
  calendarLink?: string;
}

export const ClassRescheduledEmail: React.FC<ClassRescheduledEmailProps> = ({
  name = 'João Silva',
  company = 'Trivium',
  supportEmail = 'suporte@trivium.com.br',
  domain = 'trivium.com.br',
  classDetails = {
    name: 'Introdução ao TypeScript',
    oldDate: '15/08/2023',
    oldTime: '19:00',
    newDate: '18/08/2023',
    newTime: '14:00',
    duration: '1 hora e 30 minutos',
    location: 'Online (Zoom)',
    instructor: 'Ana Souza',
    meetingLink: 'https://zoom.us/j/1234567890',
    reasonForReschedule: 'Indisponibilidade do instrutor na data original',
  },
  accountLink = 'https://trivium.com.br/minha-conta',
  calendarLink = 'https://trivium.com.br/calendar/add?event=intro-typescript-18082023',
}) => {
  return (
    <div style={containerStyle}>
      {/* Header */}
      <div style={headerStyle}>
        <img 
          src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Logo%20Trivium%20Rebranded%20Branco%20150%20dpi-0VfiiO2tOZNdZlvY5A7z3saYZGysgq.png" 
          alt="Trivium"
          style={logoImageStyle}
        />
      </div>
      
      {/* Content */}
      <div style={contentStyle}>
        <table cellPadding="0" cellSpacing="0" border={0} width="100%" style={{ backgroundColor: '#FFF4E5' }}>
          <tr>
            <td align="center" style={{ padding: '40px 20px' }}>
              <table cellPadding="0" cellSpacing="0" border={0} width="100%" style={{ maxWidth: '400px' }}>
                {/* Círculo com ícone */}
                <tr>
                  <td align="center" style={{ paddingBottom: '30px' }}>
                    <div style={{ 
                      width: '60px', 
                      height: '60px', 
                      borderRadius: '50%', 
                      backgroundColor: '#FF9800', 
                      display: 'inline-block',
                      textAlign: 'center',
                      lineHeight: '60px'
                    }}>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: 'middle' }}>
                        <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zm-7-3h5v-5h-5v5z" fill="white"/>
                      </svg>
                    </div>
                  </td>
                </tr>
                
                {/* Título */}
                <tr>
                  <td align="center" style={{ paddingBottom: '15px' }}>
                    <h1 style={{ 
                      margin: '0',
                      fontSize: '28px',
                      color: '#333333',
                      fontWeight: '600'
                    }}>
                      Aula Reagendada
                    </h1>
                  </td>
                </tr>
                
                {/* Mensagem */}
                <tr>
                  <td align="center" style={{ paddingBottom: '25px' }}>
                    <p style={{ 
                      margin: '0',
                      fontSize: '16px',
                      color: '#666666'
                    }}>
                      Sua aula foi transferida para uma nova data
                    </p>
                  </td>
                </tr>
                
                {/* Badge */}
                <tr>
                  <td align="center">
                    <div style={{ 
                      backgroundColor: '#FF9800',
                      borderRadius: '24px',
                      color: '#FFFFFF',
                      fontWeight: '600',
                      fontSize: '15px',
                      padding: '12px 25px',
                      display: 'inline-block'
                    }}>
                      {classDetails.newDate} às {classDetails.newTime}
                    </div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
        
        <div style={contentContainerStyle}>
          <h2 style={titleStyle}>Olá, {name}!</h2>
          
          <p style={paragraphStyle}>
            Gostaríamos de informar que sua aula de <strong>{classDetails.name}</strong> foi reagendada. 
            A aula que estava marcada para <strong>{classDetails.oldDate} às {classDetails.oldTime}</strong> foi 
            transferida para <strong>{classDetails.newDate} às {classDetails.newTime}</strong>.
          </p>
          
          {classDetails.reasonForReschedule && (
            <p style={paragraphStyle}>
              <strong>Motivo do reagendamento:</strong> {classDetails.reasonForReschedule}
            </p>
          )}
        </div>
        
        <div style={detailsCardStyle}>
          <h3 style={detailsHeadingStyle}>Detalhes da Aula Reagendada</h3>
          
          <div style={detailsGridStyle}>
            <div style={detailItemStyle}>
              <div style={detailIconStyle}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z" fill="#1F1746"/>
                </svg>
              </div>
              <div>
                <div style={detailLabelStyle}>Data e Horário:</div>
                <div style={detailValueStyle}>{classDetails.newDate} às {classDetails.newTime}</div>
              </div>
            </div>
            
            <div style={detailItemStyle}>
              <div style={detailIconStyle}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z" fill="#1F1746"/>
                </svg>
              </div>
              <div>
                <div style={detailLabelStyle}>Duração:</div>
                <div style={detailValueStyle}>{classDetails.duration}</div>
              </div>
            </div>
            
            <div style={detailItemStyle}>
              <div style={detailIconStyle}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 12c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6-1.8C18 6.57 15.35 4 12 4s-6 2.57-6 6.2c0 2.34 1.95 5.44 6 9.14 4.05-3.7 6-6.8 6-9.14zM12 2c4.2 0 8 3.22 8 8.2 0 3.32-2.67 7.25-8 11.8-5.33-4.55-8-8.48-8-11.8C4 5.22 7.8 2 12 2z" fill="#1F1746"/>
                </svg>
              </div>
              <div>
                <div style={detailLabelStyle}>Local:</div>
                <div style={detailValueStyle}>{classDetails.location}</div>
              </div>
            </div>
            
            <div style={detailItemStyle}>
              <div style={detailIconStyle}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 7c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4zm6 5H6v-.99c.2-.72 3.3-2.01 6-2.01s5.8 1.29 6 2v1z" fill="#1F1746"/>
                </svg>
              </div>
              <div>
                <div style={detailLabelStyle}>Instrutor:</div>
                <div style={detailValueStyle}>{classDetails.instructor}</div>
              </div>
            </div>
          </div>
          
          {classDetails.meetingLink && (
            <div style={meetingLinkContainerStyle}>
              <p style={meetingTextStyle}>
                <strong>Link para acesso:</strong> 
              </p>
              <a href={classDetails.meetingLink} style={meetingLinkStyle} target="_blank" rel="noopener noreferrer">
                Acessar Reunião Online
              </a>
            </div>
          )}
        </div>
        
        <div style={actionsContainerStyle}>
          <div style={buttonContainerStyle}>
            <a href={calendarLink} style={buttonStyle}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '8px', verticalAlign: 'text-top' }}>
                <path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2zm-7 5h5v5h-5v-5z" fill="white"/>
              </svg>
              Adicionar ao Calendário
            </a>
          </div>
          
          <p style={ctaTextStyle}>
            Você também pode verificar todos os seus agendamentos em sua conta:
          </p>
          <div style={secondaryButtonContainerStyle}>
            <a href={accountLink} style={secondaryButtonStyle}>
              Minha Conta
            </a>
          </div>
        </div>
        
        <div style={noteStyle}>
          <div style={noteIconStyle}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="#FF9800"/>
            </svg>
          </div>
          <p style={noteTextStyle}>
            <strong>Importante:</strong> Se você não puder comparecer na nova data, entre em contato conosco o mais breve possível para que possamos encontrar uma solução alternativa.
          </p>
        </div>
        
        <hr style={hrStyle} />
        
        <div style={footerContentStyle}>
          <p style={footerStyle}>
            Se você tiver alguma dúvida, entre em contato conosco:
          </p>
          <div style={contactChannelsStyle}>
            <p style={contactChannelStyle}>✉️ {supportEmail}&nbsp;&nbsp;📱 (11) 3181-5940</p>
          </div>
          <p style={footerStyle}>
            Atenciosamente,<br />
            Equipe {company}
          </p>
        </div>
      </div>
      
      {/* Footer */}
      <div style={emailFooterStyle}>
        <p style={copyrightStyle}>
          © 2025 {company}. Todos os direitos reservados.
        </p>
        <div style={footerLinksStyle}>
          <a href={`https://${domain}/termos`} style={footerLinkStyle}>Termos de Uso</a>
          <span style={footerDividerStyle}>|</span>
          <a href={`https://${domain}/privacidade`} style={footerLinkStyle}>Política de Privacidade</a>
        </div>
      </div>
    </div>
  );
};

// Estilos
const brandColor = '#1F1746';
const accentColor = '#FF9800';
const backgroundColor = '#F5F7FA';
const textColor = '#333333';
const secondaryTextColor = '#666666';

const containerStyle = {
  fontFamily: "'Satoshi', Arial, sans-serif",
  maxWidth: '600px',
  margin: '0 auto',
  backgroundColor: backgroundColor,
};

const headerStyle = {
  backgroundColor: brandColor,
  padding: '25px',
  textAlign: 'center' as const,
  borderTopLeftRadius: '8px',
  borderTopRightRadius: '8px',
};

const logoImageStyle = {
  maxWidth: '180px',
  height: 'auto',
  display: 'block',
  margin: '0 auto',
};

const contentStyle = {
  backgroundColor: '#ffffff',
  borderRadius: '0 0 8px 8px',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.05)',
  padding: '0',
  margin: '0 0 20px 0',
  overflow: 'hidden',
};

const contentContainerStyle = {
  padding: '0 40px',
};

const titleStyle = {
  fontSize: '24px',
  fontWeight: '600',
  color: brandColor,
  marginBottom: '16px',
  padding: '24px 0 0 0',
};

const paragraphStyle = {
  fontSize: '16px',
  lineHeight: '24px',
  color: textColor,
  margin: '16px 0',
};

const detailsCardStyle = {
  backgroundColor: '#F8F9FA',
  borderRadius: '8px',
  margin: '24px 40px',
  padding: '24px',
};

const detailsHeadingStyle = {
  fontSize: '18px',
  fontWeight: '600',
  color: brandColor,
  margin: '0 0 20px 0',
};

const detailsGridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(1, 1fr)',
  gap: '20px',
  marginBottom: '20px',
};

const detailItemStyle = {
  display: 'flex',
  alignItems: 'flex-start',
};

const detailIconStyle = {
  width: '36px',
  marginRight: '12px',
};

const detailLabelStyle = {
  fontSize: '14px',
  color: secondaryTextColor,
  marginBottom: '4px',
  fontWeight: '500',
};

const detailValueStyle = {
  fontSize: '16px',
  color: textColor,
  fontWeight: '500',
};

const meetingLinkContainerStyle = {
  marginTop: '20px',
  padding: '16px',
  backgroundColor: '#E8F4FD',
  borderRadius: '6px',
  display: 'flex',
  flexDirection: 'column' as const,
  alignItems: 'center',
};

const meetingTextStyle = {
  fontSize: '15px',
  color: textColor,
  margin: '0 0 12px 0',
};

const meetingLinkStyle = {
  backgroundColor: '#3E5FBA',
  color: '#ffffff',
  textDecoration: 'none',
  fontWeight: '600',
  fontSize: '14px',
  padding: '8px 16px',
  borderRadius: '4px',
  display: 'inline-block',
};

const actionsContainerStyle = {
  textAlign: 'center' as const,
  padding: '0 40px 24px 40px',
};

const buttonContainerStyle = {
  margin: '24px 0',
};

const buttonStyle = {
  backgroundColor: accentColor,
  color: '#ffffff',
  textDecoration: 'none',
  fontWeight: '600',
  fontSize: '16px',
  padding: '12px 24px',
  borderRadius: '6px',
  display: 'inline-block',
};

const secondaryButtonContainerStyle = {
  margin: '16px 0',
};

const secondaryButtonStyle = {
  backgroundColor: '#ffffff',
  color: brandColor,
  textDecoration: 'none',
  fontWeight: '600',
  fontSize: '16px',
  padding: '10px 20px',
  borderRadius: '6px',
  display: 'inline-block',
  border: `1px solid ${brandColor}`,
};

const ctaTextStyle = {
  fontSize: '15px',
  color: secondaryTextColor,
  margin: '8px 0',
};

const noteStyle = {
  display: 'flex',
  alignItems: 'flex-start',
  backgroundColor: '#FFF8E1',
  borderRadius: '6px',
  padding: '16px 20px',
  margin: '0 40px 24px 40px',
};

const noteIconStyle = {
  marginRight: '12px',
  flexShrink: 0,
};

const noteTextStyle = {
  fontSize: '15px',
  color: textColor,
  margin: '0',
  lineHeight: '1.5',
};

const hrStyle = {
  borderColor: '#E1E4E8',
  margin: '24px 40px',
};

const footerContentStyle = {
  padding: '0 40px 32px 40px',
};

const footerStyle = {
  fontSize: '14px',
  color: secondaryTextColor,
  margin: '8px 0',
};

const contactChannelsStyle = {
  display: 'flex',
  flexDirection: 'column' as const,
  alignItems: 'center',
  marginBottom: '20px',
  marginTop: '8px',
};

const contactChannelStyle = {
  fontSize: '15px',
  color: textColor,
  margin: '6px 0',
  fontWeight: '500',
};

const emailFooterStyle = {
  backgroundColor: backgroundColor,
  padding: '24px 40px',
  textAlign: 'center' as const,
  borderBottomLeftRadius: '8px',
  borderBottomRightRadius: '8px',
};

const copyrightStyle = {
  fontSize: '13px',
  color: secondaryTextColor,
  margin: '0 0 12px 0',
};

const footerLinksStyle = {
  margin: '8px 0',
};

const footerLinkStyle = {
  color: brandColor,
  textDecoration: 'none',
  fontSize: '13px',
  fontWeight: '500',
};

const footerDividerStyle = {
  color: secondaryTextColor,
  margin: '0 8px',
};

export default ClassRescheduledEmail; 